/**
 * Created by JasonChou on 17/6/14.
 */
import React, {Component} from 'react'
import {gridHelper}from '../../utils/uiUtils';
export default class Grid extends Component {
    render() {
        return (<div {...this.props} className="grid"/>)
    }
}
Grid.gridHelper = gridHelper;


// WEBPACK FOOTER //
// ./src/components/layouts/Grid.js